module.exports = __webpack_public_path__ + "img/bandeau_bravo.f2878ed5.png";